<div class="container">
  <mic-breadcrumb id="casing-purchase-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingPurchaseText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="casing-purchase-heading">{{ translationService.translate('casingPurchaseText') }}</h2>

  <div class="action-bar">
    <button id="clear-filters" class="btn-clear" type="button" mat-flat-button color="accent" (click)="clearFilters()">
      <mat-icon>refresh</mat-icon> {{ translationService.translate('clearFiltersText') }}
    </button>
    <button
      id="add-button"
      class="btn-primary"
      type="button"
      mat-flat-button
      color="primary"
      (click)="createCasingPurchase()"
      [disabled]="productSaveDisabled"
    >
      <mat-icon>add</mat-icon> {{ translationService.translate('createButtonText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="codeDropdown"
          label="{{ translationService.translate('codeText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('codeText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('codeText') }}"
          [formGroup]="filterForm"
          formControlName="code"
          [data]="codesList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="descriptionDropdown"
          label="{{ translationService.translate('descriptionText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          [formGroup]="filterForm"
          formControlName="description"
          [data]="descriptionList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="casing-purchase-table" class="cam-table table-container">
    <mic-table appCopyOnSelect #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container id="table-menu" *micTableRowMenu="let item">
        <button id="copy-button" type="button" mat-menu-item (click)="copyCasingPurchase(item)">
          <mat-icon>content_copy</mat-icon> {{ translationService.translate('copyText') }}
        </button>
        <button
          [disabled]="this.productSaveDisabled"
          id="assign-to-customer-button"
          type="button"
          mat-menu-item
          (click)="assignToCustomer(item)"
        >
          <mat-icon>person_add_alt</mat-icon> {{ translationService.translate('assignToCustomerMenuText') }}
        </button>
      </ng-container>
    </mic-table>
  </div>
</div>
